export const demoFolder = "Demos";
